module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Discover more"},"it":{"title":"Sfrutta le potenzialità delle stories","text":"Per ogni servizio potrai scegliere foto e testi personalizzati, che saranno mostrati come stories d\u0027impatto e accattivanti: per un messaggio mirato e d\u0027effetto"}}')
  delete Component.options._Ctor
}
